import {Box, Paper, Typography} from "@mui/material";
import {EmojiEvents as TrophyIcon, ArrowForward} from "@mui/icons-material";
import {colors, borders, shadows} from "../../ui/colors";

const typeLabels = {
    weight: "משקל",
    reps: "חזרות",
    volume: "נפח",
};

const PersonalRecordsCards = ({personalRecords}) => {
    if (!personalRecords || personalRecords.length === 0) return null;

    return (
        <Paper
            elevation={0}
            sx={{
                border: borders.default,
                borderRadius: borders.radius.lg,
                boxShadow: shadows.card,
                overflow: "hidden",
                direction: "rtl",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    padding: {xs: "12px 16px", md: "20px 24px"},
                    borderBottom: borders.default,
                }}
            >
                <TrophyIcon sx={{color: colors.warning}}/>
                <Typography sx={{fontSize: "18px", fontWeight: 600, color: colors.textPrimary}}>
                    שיאים אישיים
                </Typography>
                <Box
                    sx={{
                        backgroundColor: colors.warningBg,
                        color: colors.warningText,
                        fontSize: "12px",
                        fontWeight: 600,
                        padding: "2px 10px",
                        borderRadius: borders.radius.full,
                    }}
                >
                    {personalRecords.length}
                </Box>
            </Box>

            {/* Records */}
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    padding: {xs: "14px 16px", md: "20px 24px"},
                }}
            >
                {personalRecords.map((record, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            flex: {xs: "1 1 100%", sm: "1 1 calc(50% - 8px)", md: "1 1 calc(33% - 12px)"},
                            minWidth: "200px",
                            padding: "16px",
                            backgroundColor: colors.warningBg,
                            border: `1px solid ${colors.warning}33`,
                            borderRadius: borders.radius.md,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                        }}
                    >
                        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                            <Typography sx={{fontSize: "14px", fontWeight: 600, color: colors.textPrimary}}>
                                {record.exerciseNameHeb || record.exerciseName}
                            </Typography>
                            <Box
                                sx={{
                                    fontSize: "10px",
                                    fontWeight: 600,
                                    color: colors.warningText,
                                    backgroundColor: `${colors.warning}22`,
                                    padding: "2px 8px",
                                    borderRadius: borders.radius.full,
                                    textTransform: "uppercase",
                                }}
                            >
                                {typeLabels[record.type] || record.type}
                            </Box>
                        </Box>

                        <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                            <Typography sx={{fontSize: "16px", fontWeight: 500, color: colors.textMuted, textDecoration: "line-through"}}>
                                {record.previousBest != null ? Math.round(record.previousBest) : "—"}
                            </Typography>
                            <ArrowForward sx={{fontSize: 16, color: colors.warning}}/>
                            <Typography sx={{fontSize: "20px", fontWeight: 700, color: colors.warningText}}>
                                {record.newBest != null ? Math.round(record.newBest) : "—"}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Paper>
    );
};

export default PersonalRecordsCards;
